module.exports = __webpack_public_path__ + "static/media/F4.a9470efb.png";